import { en_ca } from "../en_ca";

export const en_ca_hosp = {
  ...en_ca
};
